import { createMuiTheme } from '@material-ui/core/styles'
import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'

const theme = {
  'default': {
    primary: 'rgb(0,44,66)',
    secondary: 'rgb(0,159,140)',
    error: '#F05D5E'
  },
  'orange-black': {
    primary: '#000000',
    secondary: '#FB9D00',
    error: '#F05D5E'
  },
  'blue-black': {
    primary: '#000000',
    secondary: '#2E9AFE',
    error: '#F05D5E'
  },
  'white': {
    primary: '#FFFFFF',
    secondary: '#2E9AFE',
    error: '#F05D5E'
  },
  'white-orange': {
    primary: '#f39c12',
    secondary: '#FFFFFF',
    error: '#F05D5E'
  },
  'ultraviolet-moutarde': {
    primary: '#321E5C',
    secondary: '#FFD902',
    error: '#F05D5E'
  },
  'flat': {
    primary: '#2980b9',
    secondary: '#2ecc71',
    error: '#F05D5E'
  },
}

export default () => {

  let themeUser = Constants.themeUI[User.User.get().theme_id]
  if (themeUser === undefined) {
    themeUser = 'default'
  }
  return generateStyle(theme[themeUser])
}

const generateStyle = (color) => createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    text: {
      error: {
        main: color.error,
      },
    },
    primary: {
      main: color.primary,
    },
    secondary: {
      main: color.secondary,
    },
    error: {
      main: color.error,
    },
  },
  spacing: factor => [0, 4, 8, 16, 32, 64][factor],
  overrides: {
    MuiGrid: {
      container: {
        margin: 0,
        padding: 0
      },
      item: {
        margin: 0,
        padding: 0
      }
    },
    MuiButtonBase: {
      root: {
        padding: 1,
        minHeight: 'inherit',
        textTransform: 'none',
      }
    },
    MuiFormControl: {
      root: {
        zIndex: 'inherit'
      }
    },
    MuiFab: {
      root: {
        padding: 1,
        minHeight: 'inherit',
        textTransform: 'none'
      },
      sizeSmall: {
        height: 24,
        width: 24,
        minHeight: 24,
        minWidth: 24,
        padding: 1
      }
    },
    MuiCheckbox: {
      root: {
        '&$checked': {
          color: color.primary
        }
      }
    },
    MuiButton: {
      root: {
        padding: 1,
        minHeight: 'inherit',
        textTransform: 'none',
        minWidth: 35
      },
      text: {
        padding: '0px 6px'
      },
      sizeSmall: {
        height: 'auto',
        width: 'auto',
        minHeight: 24,
        minWidth: 24,
        padding: 1
      }
    },
    MuiInputAdornment: {
      positionEnd: {
        marginRight: 10,
        marginLeft: 1
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: 'white',
        border: 'none',
        boxShadow: '0 0 0 1px ' + color.primary,
        borderRadius: 3,
        '&$focused $notchedOutline': {
          border: 'none',
          borderTopLeftRadius: 0,
        },
        '&$focused': {
          boxShadow: '0 0 0 2px ' + color.primary,
          border: 'none',
        },
      },
      notchedOutline: {
        border: 'none',
        backgroundColor: 'transparent',
        borderRadius: 3,
        '&$focused': {
          borderRadius: 3,
        },
      },
      input: {
        padding: '5px 2.5px 5px 2.5px',
        paddingLeft: 5,
        zIndex: 1,
      },
      adornedEnd: {
        paddingRight: 10
      },
      adornedStart: {
        paddingLeft: 10,
      },
      inputMultiline: {
        padding: '5px 2.5px 5px 2.5px',
        paddingLeft: 5,
        zIndex: 1
      },
    },
    PrivateNotchedOutline: {
      root: {
        top: 0,
        borderTopLeftRadius: 0,
        border: 'none',
      },
      legend: {
        border: 'none',
      }
    },
    MuiInputLabel: {
      outlined: {
        zIndex: 2,
        transform: 'translate(8px, 18px) scale(1)',
        '&$shrink': {
          backgroundColor: 'white',
          //zIndex: 0,
          color: 'black',
          padding: '1.5px 5px',
          //paddingRight: 28,
          //boxShadow: '0 0 0 1px ' + color.primary,
          //boxShadow: '0px 1px 1px white',
          //border: '2px solid ' + color.primary,
          //borderBottom: '1.5px solid white',
          boxShadow: '0 4px 0 white, 0 0 0 2px ' + color.primary,
          transform: 'translate(0px, -.5px) scale(0.6)',
          borderRadius: 3,
          borderBottomLeftRadius: 0,
          '&$focused': {
            boxShadow: '0 4px 0 white, 0 0 0 3px ' + color.primary,
            transform: 'translate(0px, -.5px) scale(0.6)',
            borderRadius: 3,
            borderBottomLeftRadius: 0,
            //boxShadow: '0px 3px 1px white',
          },
        },
      },
    },
    MuiTab: {
      textColorInherit: {
        opacity: 0.5,
      },
      root: {
        border: '1px solid ' + color.primary,
        maxWidth: '100%',
        minWidth: 'none',
        fontWeight: 600,
        maxHeight: 31,
        minHeight: 31,
        height: 31,
        backgroundColor: 'white',
        color: color.primary,
        padding: '0 10px'
      },
    },
    MuiTabs: {
      root: {
        maxHeight: 31,
        minHeight: 31,
        height: 31,
        background: 'transparent',
        color: color.primary
      },
    },
    MuiIconButton: {
      root: {
        padding: 0,
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    MuiList: {
      root: {
        padding: 0
      },
      padding: {
        paddingTop: 0,
        paddingBottom: 0
      }
    },
    MuiMenuItem: {
      root: {
        minHeight: 'none'
      },
      gutters: {
        lineHeight: '.8em',
        padding: '2px 0px'
      }
    },
    MuiSelect: {
      select: {
        paddingRight: 0,
        textAlign: 'left'
      },
      icon: {
        width: 17,
        right: 5,
        color: 'rgba(0, 0, 0, 0.54)'
      }
    },
    MuiInput: {
      underline: {
        border: 'none',
      }
    },
    MuiSwitch: {
      root: {
        padding: 0,
        height: 22,
        width: 42
      },
      switchBase: {
        color: color.error,
        '&$checked': {
          color: color.secondary,
          transform: 'translateX(85%)'
        },
      },
    },
    PrivateSwitchBase: {
      root: {
        padding: 1
      }
    },
    MuiNotchedOutline: {
      '&$focused': {
        border: '2px solid ' + color.primary
      }
    },
    TabIndicator: {
      backgroundColor: color.secondary
    },
    MuiTypography: {
      body1: {
        color: color.primary,
      }
    },
    MuiPickersCalendarHeader: {
      dayLabel: {
        margin: '0px 2.5px',
      },
      switchHeader: {
        padding: '5px 20px 5px 20px'
      },
      iconButton: {
        '&$MuiIconButton-disabled': {
          color: color.error
        }
      }
    },
    MuiPickersDay: {
      day: {
        width: 36,
        height: 36,
        fontSize: 12,
        color: color.primary,
        borderRadius: 5,
        border: '1px solid ' + color.primary,
        margin: 2.5,
      },
      isSelected: {
        color: 'white',
        backgroundColor: color.primary,
      },
      isDisabled: {
        cursor: 'not-allowed',
        color: color.error,
        border: 'none',
      },
      current: {
        color: 'grey',
      },
    },
    MuiPickersBasePicker: {
      pickerView: {
        minHeight: 'none',
        padding: '10px 0px 40px 0px',
        justifyContent: 'flex-start'
      }
    },
    MuiTooltip: {
      tooltip: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: color.primary,
        backgroundColor: 'white',
        color: color.primary,
        maxWidth: '100%',
        '@media (min-width: 600px)': {
          maxWidth: '100%',
        }
      },
      tooltipPlacementBottom: {
        margin: '4px 0px',
        padding: 0,
        '@media (min-width: 600px)': {
          margin: '0px 4px',
          padding: 0,
        }
      },
      tooltipPlacementTop: {
        margin: '4px 0px',
        padding: 0,
        '@media (min-width: 600px)': {
          margin: '0px 4px',
          padding: 0,
        }
      },
      tooltipPlacementRight: {
        margin: '0px 4px',
        padding: 0,
        '@media (min-width: 600px)': {
          margin: '0px 4px',
          padding: 0,
        }
      },
      tooltipPlacementLeft: {
        margin: '0px 4px',
        padding: 0,
        '@media (min-width: 600px)': {
          margin: '0px 4px',
          padding: 0,
        }
      },
    },
    /*MuiTooltip: {
      tooltip: {
        backgroundColor: color.primary,
        borderRadius: 5,
        fontSize: 15,
        border: '2px solid ' + color.secondary,
        padding: 0
      },
    },*/
    PrivateValueLabel: {
      circle: {
        width: 20,
        height: 20
      },
      offset: {
        letterSpacing: 'none',
        top: -15,
        left: 'none'
      }
    },
    MuiDialog: {
      paperWidthSm: {
        maxWidth: '100%',
        background: 'transparent'
      },
      paperScrollPaper: {
        maxHeight: '100vh'
      }

    },
    MuiPaper: {
      elevation1: {
        backgroundColor: 'white',
        borderRadius: 5,
        boxShadow: `0 0 0 1px ${color.primary}, 1px 1px 3px lightgrey, -1px 1px 3px lightgrey`
      }
    },
    MuiSnackbarContent: {
      root: {
        color: 'grey',
        backgroundColor: 'white',
        borderRadius: 5,
      }
    },
    SnackbarItem: {
      'variantError-*': {
        backgroundColor: 'white',
        border: '1px solid #DC3545',
      },
      'variantSuccess-*': {
        backgroundColor: 'white',
        border: '1px solid #03BD5B',
      }
    },
    MuiTableCell: {
      root: {
        borderRight: '1px solid #C9D3DF',
        padding: '5px 4px 2px 4px',
      },
      body: {
        color: 'inherit',
        border: 'thin solid #C9D3DF',
        borderTop: 'none',
        '&:not(:first-child)': {
          borderLeft: 'none',
        }
      },
      head: {
        borderRight: '1px solid #C9D3DF',
        cursor: 'pointer',
        boxShadow: '0 1px 3px 0px ' + color.primary,
        color: color.primary,
        fontWeight: 'bold',
        fontSize: '0.9rem',
      },
      stickyHeader: {
        backgroundColor: 'white'
      }
    },
    MuiAppBar: {
      positionStatic: { transform: 'none' }
    },
    MuiTableRow: {
      root: {
        '&:nth-of-type(odd)': {
          backgroundColor: 'rgba(251,251,251,1)',
          '&$selected': {
            backgroundColor: color.secondary,
            color: 'white'
          },
          '&$hover:hover': {
            backgroundColor: color.primary,
            color: 'white',
          }
        },
        '&:nth-of-type(even)': {
          backgroundColor: 'rgba(251,251,251,1)',
          '&$selected': {
            backgroundColor: color.secondary,
            color: 'white'
          },
          '&$hover:hover': {
            backgroundColor: color.primary,
            color: 'white',
          }
        },
        backgroundColor: 'white',
        '&$selected': {
          backgroundColor: color.secondary,
          color: 'white',
        },
        '&$hover:hover': {
          backgroundColor: color.primary,
          color: 'white',
        }
      },
    }
  }
})



// WEBPACK FOOTER //
// ./app/App/Static/Style/index.js